import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LichPhoBiens {
  name: string;
  api_token: string;
}

export interface LichPhoBiensListInfor {
  errors: unknown;
  lichPhoBiens: LichPhoBiens;
  isAuthenticated: boolean;
}

@Module
export default class LichPhoBiensModule
  extends VuexModule
  implements LichPhoBiensListInfor
{
  errors = {};
  lichPhoBiens = {} as LichPhoBiens;
  isAuthenticated = !!JwtService.getToken();

  get LichPhoBiens() {
    return this.lichPhoBiensListData;
  }

  @Mutation
  [Mutations.LICH_PHO_BIENS_LIST_DATA](LichPhoBiens) {
    this.lichPhoBiensListData = LichPhoBiens;
  }

  @Action
  [Actions.LICH_PHO_BIENS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/lichphobien", payload)
        .then((data) => {
          this.context.commit(Mutations.LICH_PHO_BIENS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LICH_PHO_BIEN_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("lichphobien/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.LICH_PHO_BIENS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LICH_PHO_BIEN_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/lichphobien", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.LICH_PHO_BIENS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LICH_PHO_BIEN_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/lichphobien",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.LICH_PHO_BIENS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LICH_PHO_BIEN_UPDATE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/lichphobien/${payload.id}/update-status`,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.LICH_PHO_BIENS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
